export function aliasKey(alias) {
  return typeof alias === 'string' ? alias : alias.key;
}

export function containsTerm(key, value) {
  return { debugData: { _contains: { [key]: value } } };
}
